/* eslint-disable @typescript-eslint/no-explicit-any */
import { ThunkActionTypes } from './types';
import { ServiceCMS } from '../../services/axios';
import { onSetDocuments, onSetEnabledSpinner } from '../reducer/common/actions';
import { GetHomeDataRequest } from '../reducer/app/types';
import { onGetGlobalDataSuccess } from '../reducer/common/actions';
import { TypeCallAPIEnum } from '../../lib/constants';
import { GlobalDataVM } from '../reducer/common/types';
import { GetGlobalDataModel } from '../../models/global-data.model';
import { DocumentsModel, PagingModel } from '../../models/common.models';
import { NewVM } from '@/core/models/news.model';
import { PagingParamVM } from '@/views/news-v2/news-v2.component';
import { ResearchResponse, ResearchVM } from '@/core/models/research.model';

export const onThunkGetGlobalDataCMS =
  ({ wpml_language }: GetHomeDataRequest, baseUrl: string, token: string): ThunkActionTypes =>
  async (dispatch) => {
    dispatch(onSetEnabledSpinner(true));
    try {
      const service = new ServiceCMS();
      const body = JSON.stringify({
        type: TypeCallAPIEnum.Static,
        locale: [`${wpml_language.split('-')[0]}`],
        key: [
          {
            'global-data': [
              'Header_Logo',
              'Header_Alternative_Logo',
              'Address_1',
              'Address_2',
              'Address_3',
              'Intro',
              'Footer_Copyright',
              'Email',
              'Phone',
              'Facebook',
              'LinkedIn',
              'Youtube',
              'Twitter',
              'Footer_Logo',
              'Link_BellePro_AppStore',
              'Link_BellePro_GooglePlay',
              'FaxNumber',
            ],
          },
        ],
      });

      const res: any = await service.call('POST', baseUrl, '/api/contents', body, token);

      if (res) {
        const response: GetGlobalDataModel = res;

        const temp: GlobalDataVM = {
          ...res,
          headerLogo: response.headerLogo?.[0],
          footerLogo: response.footerLogo?.[0],
          headerAlternativeLogo: response.headerAlternativeLogo?.[0],
          linkedin: response.linkedIn,
        };

        dispatch(onGetGlobalDataSuccess(temp));
      }
      dispatch(onSetEnabledSpinner(false));
    } catch (e) {
      dispatch(onSetEnabledSpinner(false));
    }
  };

export const onThunkGetDocumentLinkCMS =
  (
    { wpml_language }: GetHomeDataRequest,
    baseUrl: string,
    token: string,
    groupby?: string[],
  ): ThunkActionTypes =>
  async (dispatch) => {
    dispatch(onSetEnabledSpinner(true));
    let category: string[] = [];
    if (groupby) {
      category = groupby.map((item) => {
        return item.trim();
      });
    }

    try {
      const service = new ServiceCMS();
      const body = JSON.stringify({
        type: TypeCallAPIEnum.Dynamic,
        locale: [`${wpml_language.split('-')[0]}`],
        key: [
          {
            post: [],
            limit: 10,
            offset: 0,
            groupby: category,
            sort: '-PublishTime',
          },
        ],
      });

      const res: any = await service.call('POST', baseUrl, '/api/contents', body, token);

      if (res) {
        dispatch(onSetDocuments([...(res?.post || [])] as NewVM[]));
      }
      dispatch(onSetEnabledSpinner(false));
    } catch (e) {
      dispatch(onSetEnabledSpinner(false));
    }
  };

export const onThunkGetNewsCMS =
  <T>(
    { wpml_language }: GetHomeDataRequest,
    baseUrl: string,
    token: string,
    paging: PagingParamVM,
    onSuccess?: (data: T[]) => void,
    groupby?: string[],
  ): ThunkActionTypes =>
  async (dispatch) => {
    dispatch(onSetEnabledSpinner(true));
    let category: string[] = [];
    if (groupby) {
      category = groupby.map((item) => {
        return item.trim();
      });
    }

    try {
      const service = new ServiceCMS();
      const body = JSON.stringify({
        type: TypeCallAPIEnum.Dynamic,
        locale: [`${wpml_language.split('-')[0]}`],
        key: [
          {
            post: [],
            limit: paging.limit || 100,
            offset: paging.offset,
            groupby: category,
            sort: '-PublishTime',
          },
        ],
      });

      const res: any = await service.call('POST', baseUrl, '/api/contents', body, token);
      if (res) {
        onSuccess && onSuccess(res?.post || []);
      }
      dispatch(onSetEnabledSpinner(false));
    } catch (e) {
      dispatch(onSetEnabledSpinner(false));
    }
  };

export const onThunkGetListResearch =
  (
    locale: string,
    baseUrl: string,
    token: string,
    paging: PagingModel,
    onSuccess?: (response: ResearchResponse) => void,
  ): ThunkActionTypes =>
  async (dispatch) => {
    dispatch(onSetEnabledSpinner(true));
    try {
      const service = new ServiceCMS();
      const body = JSON.stringify({
        locale: locale,
        limit: paging.limit,
        offset: paging.offset,
      });

      const res: any = await service.call('GET', baseUrl, '/api/researchs', body, token);

      if (res) {
        onSuccess && onSuccess(res);
      }
      dispatch(onSetEnabledSpinner(false));
    } catch (e) {
      dispatch(onSetEnabledSpinner(false));
    }
  };

export const onThunkGetTotalItemNewsCMS =
  (
    { wpml_language }: GetHomeDataRequest,
    baseUrl: string,
    token: string,
    onSuccess?: (totalItem: number) => void,
    groupby?: string[],
  ): ThunkActionTypes =>
  async (dispatch) => {
    dispatch(onSetEnabledSpinner(true));

    let category: string[] = [];
    if (groupby) {
      category = groupby.map((item) => {
        return item.trim();
      });
    }
    try {
      const service = new ServiceCMS();
      const body = JSON.stringify({
        source: 'post',
        locale: [`${wpml_language.split('-')[0]}`],
        groupby: category,
      });

      const res: any = await service.call('POST', baseUrl, '/api/contents-count', body, token);

      if (res) {
        onSuccess && onSuccess(Number(res));
      }
      dispatch(onSetEnabledSpinner(false));
    } catch (e) {
      dispatch(onSetEnabledSpinner(false));
    }
  };

export const onThunkGetNewDetailCMS =
  (
    { wpml_language }: GetHomeDataRequest,
    baseUrl: string,
    token: string,
    slug: string,
    onSuccess?: (data: NewVM[]) => void,
  ): ThunkActionTypes =>
  async (dispatch) => {
    dispatch(onSetEnabledSpinner(true));
    try {
      const service = new ServiceCMS();
      const body = JSON.stringify({
        type: TypeCallAPIEnum.Dynamic,
        locale: [`${wpml_language.split('-')[0]}`],
        key: [
          {
            post: [slug],
          },
        ],
      });

      const res: any = await service.call('POST', baseUrl, '/api/contents', body, token);

      if (res) {
        onSuccess && onSuccess(res?.post || []);
      }
      dispatch(onSetEnabledSpinner(false));
    } catch (e) {
      dispatch(onSetEnabledSpinner(false));
    }
  };

// get language CMS

export const onThunkGetlanguageCMS =
  (
    { wpml_language }: GetHomeDataRequest,
    baseUrl: string,
    token: string,
    onSuccess?: (data: any) => void,
  ): ThunkActionTypes =>
  async (dispatch) => {
    dispatch(onSetEnabledSpinner(true));
    try {
      const service = new ServiceCMS();
      const body = JSON.stringify({
        type: TypeCallAPIEnum.Static,
        locale: [`${wpml_language.split('-')[0]}`],
        isNested: false,
        key: [
          {
            'translate-belle-website': [],
          },
        ],
        getType: 'json',
      });

      const res: any = await service.call('POST', baseUrl, '/api/contents', body, token, true);

      if (res && res.success) {
        onSuccess && onSuccess(res);
        console.log(res);
      }
      dispatch(onSetEnabledSpinner(false));
    } catch (e) {
      dispatch(onSetEnabledSpinner(false));
    }
  };
